"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_renderType", function () {
      var _this$props$fields = _this.props.fields,
        visualType = _this$props$fields.visualType,
        width = _this$props$fields.width,
        height = _this$props$fields.height,
        inputPrepend = _this$props$fields.inputPrepend,
        inputAddon = _this$props$fields.inputAddon,
        isTypeExpanded = _this$props$fields.isTypeExpanded;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Formatting",
        type: _this.props.formBlockType,
        isError: (0, _cccisdSurveyCommon.checkForErrors)([width, height]),
        show: isTypeExpanded.value,
        handleClick: function handleClick(show) {
          return isTypeExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Style"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(visualType), {
        value: "textarea",
        checked: visualType.value === 'textarea'
      })), ' ', "Multi-line"), /*#__PURE__*/_react["default"].createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "radio"
      }, (0, _domOnlyProps["default"])(visualType), {
        value: "input",
        checked: visualType.value === 'input'
      })), ' ', "Single line"))), visualType.value === 'input' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: inputPrepend,
        label: "Preceding text"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: inputAddon,
        label: "Following text"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'row ' + _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: width,
        label: "Max width"
      })), visualType.value === 'textarea' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: height,
        label: "Height"
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderRequired", function () {
      var _this$props$fields2 = _this.props.fields,
        isRequiredExpanded = _this$props$fields2.isRequiredExpanded,
        isRequired = _this$props$fields2.isRequired,
        requiredErrorMessage = _this$props$fields2.requiredErrorMessage;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Required",
        type: _this.props.formBlockType,
        show: isRequiredExpanded.value,
        handleClick: function handleClick(show) {
          return isRequiredExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: _objectSpread({
          marginTop: 0
        }, !isRequired.value && {
          marginBottom: 0
        })
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(isRequired))), " Require an answer")), isRequired.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: requiredErrorMessage,
        label: "Required error message"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderValidation", function () {
      var _this$props$fields3 = _this.props.fields,
        minCharacters = _this$props$fields3.minCharacters,
        maxCharacters = _this$props$fields3.maxCharacters,
        minNumber = _this$props$fields3.minNumber,
        maxNumber = _this$props$fields3.maxNumber,
        isValidationExpanded = _this$props$fields3.isValidationExpanded,
        validationRule = _this$props$fields3.validationRule,
        minCharactersErrorMessage = _this$props$fields3.minCharactersErrorMessage,
        numberErrorMessage = _this$props$fields3.numberErrorMessage,
        minNumberErrorMessage = _this$props$fields3.minNumberErrorMessage,
        maxNumberErrorMessage = _this$props$fields3.maxNumberErrorMessage,
        emailErrorMessage = _this$props$fields3.emailErrorMessage,
        phoneErrorMessage = _this$props$fields3.phoneErrorMessage,
        dateErrorMessage = _this$props$fields3.dateErrorMessage,
        regex = _this$props$fields3.regex,
        regexErrorMessage = _this$props$fields3.regexErrorMessage;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Validation",
        type: _this.props.formBlockType,
        isError: (0, _cccisdSurveyCommon.checkForErrors)([minCharacters, maxCharacters]),
        show: isValidationExpanded.value,
        handleClick: function handleClick(show) {
          return isValidationExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: validationRule.value === 'none' ? _common["default"].lastRow : ''
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: validationRule,
        label: "Validation rule"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control",
        value: validationRule.value,
        onChange: function onChange(event) {
          return validationRule.onChange(event.target.value);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "none"
      }, "No validation"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "length"
      }, "Min/Max characters"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "email"
      }, "Email"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "number"
      }, "Whole number"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "regex"
      }, "Regex")))), validationRule.value === 'email' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: emailErrorMessage,
        label: "Error message"
      })), validationRule.value === 'regex' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: regex,
        comment: "For example: /^something$/i",
        label: "Regular Expression"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: regexErrorMessage,
        label: "Error message"
      }))), validationRule.value === 'length' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minCharacters,
        label: "Min characters"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxCharacters,
        label: "Max characters"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minCharactersErrorMessage,
        label: "Error message when less than min"
      }))), validationRule.value === 'number' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minNumber,
        label: "Min number"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxNumber,
        label: "Max number"
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: numberErrorMessage,
        label: "Error message when it's not a number"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minNumberErrorMessage,
        label: "Error message when less than min"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxNumberErrorMessage,
        label: "Error message when more than max"
      }))), validationRule.value === 'phone' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: phoneErrorMessage,
        label: "Error message"
      })), validationRule.value === 'date' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: dateErrorMessage,
        label: "Error message"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDefaultValue", function () {
      var _this$props$fields4 = _this.props.fields,
        defaultValue = _this$props$fields4.defaultValue,
        visualType = _this$props$fields4.visualType;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Default value",
        type: _this.props.formBlockType
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: defaultValue,
        label: "Initial text for respondent to edit"
      }, visualType.value === 'textarea' && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: defaultValue.value,
        onChange: defaultValue.onChange,
        type: "input",
        settings: {
          toolbar: ['cccisdVariables']
        }
      }), visualType.value === 'input' && /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: "form-control",
        onChange: function onChange() {}
      }, (0, _domOnlyProps["default"])(defaultValue))))));
    });
    return _this;
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields5 = this.props.fields,
        question = _this$props$fields5.question,
        description = _this$props$fields5.description;
      return /*#__PURE__*/_react["default"].createElement("div", null, !this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        onChange: question.onChange,
        type: "textarea-inline",
        selectAllOnFocus: question.value === _settings.initialValues.question
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        type: "textarea-inline",
        onChange: description.onChange
      }))), this._renderType(), this._renderRequired(), this._renderValidation(), this._renderDefaultValue());
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  formBlockType: _propTypes["default"].string,
  isMatrixMode: _propTypes["default"].bool
});
_defineProperty(Builder, "defaultProps", {
  formBlockType: 'primary',
  isMatrixMode: false
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withVisibilityConditions: true,
  withQuestionNumbers: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withDefaultValueFromVariable: true
})(Builder);